export const translations = {
  it: {
    // Nav
    admin_link: "Admin",
    admin_logout: "Esci",
    admin_settings: "Impostazioni",
    settings_deposit_label: "Anticipo a persona",
    settings_deposit_hint: "Importo richiesto come anticipo per ogni coperto su tutte le prenotazioni cena.",
    settings_deposit_per_person_suffix: "a persona",
    settings_reconcile_label: "Sincronizza pagamenti Stripe",
    settings_reconcile_hint: "Controlla su Stripe lo stato di tutte le prenotazioni in attesa di pagamento e aggiorna quelle realmente pagate.",
    settings_reconcile_action: "Sincronizza ora",
    settings_capacity_label: "Capienza per turno cena",
    settings_capacity_hint: "Imposta il numero massimo di posti prenotabili per ciascun turno. Quando un turno raggiunge il limite, i clienti non potranno più prenotarlo.",
    settings_capacity_save: "Salva",
    toast_reconcile_finalized: "prenotazioni aggiornate a pagate",
    toast_reconcile_none: "Nessuna prenotazione da sincronizzare",
    toast_reconcile_checked: "controllate",
    mark_paid_button: "Marca pagata",
    mark_paid_tooltip: "Marca questa prenotazione come pagata manualmente (override admin)",
    paid_checkbox: "Pagata",
    paid_after_cancel: "Pagata dopo l'annullamento: verifica i posti",
    check_stripe_button: "Verifica su Stripe",
    toast_stripe_paid: "Stripe conferma il pagamento: prenotazione aggiornata",
    toast_stripe_unpaid: "Su Stripe non risulta ancora nessun pagamento",
    toast_stripe_unreachable: "Stripe non raggiungibile, riprova tra poco",
    tab_awaiting_payment: "Da pagare",
    tab_paid: "Pagate",
    tab_cancelled: "Annullate",
    kpi_awaiting_payment: "Da pagare",
    kpi_paid: "Pagate",
    kpi_cancelled: "Annullate",
    status_cancelled_short: "ANNULLATA",
    payment_countdown: "Tempo per pagare",
    payment_time_over: "Tempo scaduto, annullamento in corso",
    sort_label: "Ordina per",
    sort_upcoming: "Prossime prima",
    sort_date_asc: "Data prenotazione ↑",
    sort_date_desc: "Data prenotazione ↓",
    sort_created_desc: "Richiesta più recente",
    sort_created_asc: "Richiesta più vecchia",
    sort_name_asc: "Nome A–Z",
    sort_guests_desc: "Più persone",
    filter_service_dinner: "Cena",
    filter_service_lunch: "Pranzo",
    settings_lunch_capacity_label: "Coperti per orario — pranzo della domenica",
    settings_lunch_capacity_hint: "Vale per ognuno degli orari 12:00 — 14:45.",
    lunch_sunday_only_notice: "Il pranzo è disponibile solo la domenica, con arrivi ogni 15 minuti.",
    pay_countdown_label: "Tempo rimasto per pagare",
    pay_countdown_hint: "Se il pagamento non arriva entro il tempo indicato, la prenotazione viene annullata automaticamente.",
    pay_cancelled_title: "Prenotazione annullata",
    pay_cancelled_subtitle: "Il tempo per il pagamento è scaduto e il posto è tornato disponibile. Puoi inviare una nuova richiesta.",
    mark_paid_confirm: "Vuoi marcare questa prenotazione come PAGATA? Verrà confermata e il cliente riceverà l'email di conferma.",
    toast_marked_paid: "Prenotazione marcata come pagata",
    theme_toggle: "Tema",
    language: "Lingua",

    // Landing
    tagline: "Find your Soul",
    landing_description:
      "Prenota il tuo tavolo in pochi secondi. Confermeremo la tua richiesta entro 24 ore.",
    landing_choose_service: "Scegli il momento perfetto",

    // Event CTA
    cta_event_label: "Per il tuo evento privato",
    cta_event_subtitle: "",
    event_step_title: "Disegniamo il tuo evento",
    event_step_subtitle: "Raccontaci la tua idea — il nostro team ti ricontatterà entro 48 ore.",
    event_field_type: "Tipo di evento",
    event_field_type_other: "Specifica il tipo",
    event_field_guests: "Numero di ospiti previsto",
    event_field_date: "Data preferita",
    event_field_fascia: "Fascia oraria preferita",
    event_field_description: "Raccontaci la tua idea",
    event_description_placeholder:
      "Es: Vorrei festeggiare i miei 30 anni in una sala privata con tavolata unica, DJ set dalle 22 e una torta a sorpresa…",
    event_field_budget: "Budget indicativo per persona (€, opzionale)",
    event_field_setup: "Allestimenti speciali (opzionale)",
    event_submit: "Invia richiesta evento",

    // Event types
    event_type_birthday: "Compleanno",
    event_type_anniversary: "Anniversario",
    event_type_wedding: "Matrimonio",
    event_type_baptism: "Battesimo",
    event_type_corporate: "Cena aziendale",
    event_type_private: "Festa privata",
    event_type_other: "Altro",

    // Event fascia
    fascia_lunch: "Pranzo (12—15)",
    fascia_aperitivo: "Aperitivo (16—19)",
    fascia_dinner: "Cena (19—22)",
    fascia_late: "Serata tardiva (22—24)",

    // Event setup
    setup_private_room: "Sala privata",
    setup_single_table: "Tavolata unica",
    setup_dj_music: "DJ / musica",
    setup_decorations: "Decorazioni",
    setup_cake: "Torta",
    setup_dedicated_service: "Servizio dedicato",

    event_success_title: "Richiesta evento inviata!",
    event_success_subtitle:
      "Ti abbiamo inviato una conferma via email. Il nostro team ti ricontatterà entro 48 ore.",
    event_admin_label: "Evento",

    // Services
    service_lunch: "Pranzo",
    service_aperitivo: "Aperitivo",
    service_dinner: "Cena",
    service_event: "Evento privato",
    service_lunch_hours: "Solo domenica · 12:00 — 14:45",
    service_aperitivo_hours: "16:00 — 19:00",
    service_dinner_hours: "Due turni · 20:30 — 24:00",
    service_lunch_subtitle: "Il pranzo della domenica, arrivi ogni 15 minuti",
    service_aperitivo_subtitle: "Calici al tramonto, ogni mezz'ora",
    service_dinner_subtitle: "Due turni candlelit",

    // Auth choice (after service)
    auth_title: "Come vuoi prenotare?",
    auth_subtitle: "Scegli il modo più veloce per identificarti.",
    login_instagram: "Accedi con Instagram",
    login_instagram_sub: "Veloce con il tuo nickname",
    book_as_guest: "Prenota come ospite",
    book_as_guest_sub: "Inserisci i tuoi dati",

    // Address
    address_line_1: "Via Campi Flegrei 15",
    address_line_2: "80078 Pozzuoli",
    copyright: "Copyright © 2026 VAGALUME, All rights reserved",
    credits_developed_by: "App di prenotazione sviluppata da",

    // Instagram modal
    ig_modal_title: "Accedi con Instagram",
    ig_modal_subtitle: "Entra con il tuo nickname per prenotare rapidamente.",
    ig_username_label: "Username Instagram",
    ig_username_placeholder: "il_tuo_nickname",
    ig_continue: "Continua",
    ig_cancel: "Annulla",
    ig_error_required: "Inserisci il tuo nickname Instagram.",

    // Guest form
    guest_title: "Prenota come ospite",
    guest_subtitle: "Bastano pochi dati per iniziare.",
    field_nome: "Nome",
    field_cognome: "Cognome",
    field_instagram: "Nickname Instagram (opzionale)",
    field_email: "Email",
    field_phone: "Telefono (WhatsApp)",
    phone_hint: "Formato internazionale, es. +39 333 1234567",
    guest_continue: "Continua →",
    err_required: "Campo obbligatorio",
    err_invalid_email: "Email non valida",
    err_invalid_phone: "Numero di telefono non valido",

    // Booking form
    hello: "Ciao",
    step_title: "La tua prenotazione",
    step_subtitle: "Scegli data, orario e numero di coperti.",
    field_service: "Servizio",
    change_service: "Cambia",
    field_date: "Data della prenotazione",
    date_placeholder: "Seleziona una data",
    field_time: "Orario",
    field_time_dinner: "Turno",
    field_guests: "Numero di coperti",
    field_deposit_per_person: "Anticipo a persona",
    field_deposit_per_person_hint: "Scegli l'importo dell'anticipo per ogni coperto. Il pagamento ti verrà richiesto solo dopo la nostra conferma.",
    field_deposit_total: "Totale anticipo",
    field_notes: "Note / Richieste speciali",
    notes_placeholder: "Allergie, occasione speciale, preferenze sul tavolo…",
    chars_left: "caratteri rimasti",
    field_occasion: "Occasione (opzionale)",
    field_occasion_other: "Specifica l'occasione",
    field_allergies: "Allergie / preferenze (opzionale)",
    field_allergies_note: "Altre note allergie",
    allergy_counts_label: "Quante persone per ciascuna voce?",
    allergy_counts_hint:
      "Indicare il numero esatto ci evita di doverti richiamare prima del servizio.",
    allergy_count_decrease: "Diminuisci persone",
    allergy_count_increase: "Aumenta persone",
    field_birthday: "Il tuo compleanno (opzionale)",
    birthday_hint: "Per inviarti un piccolo pensiero a ogni anniversario",

    deposit_label: "Anticipo richiesto",
    deposit_hint:
      "Il pagamento dell'anticipo sarà richiesto separatamente dopo la conferma. La prenotazione sarà confermata dall'admin entro 24 ore.",
    dinner_only_notice:
      "La prenotazione è intesa esclusivamente per il servizio di cena; per qualsiasi altro utilizzo si considera nulla.",
    terms_checkbox:
      "Confermo di aver letto e accettato le condizioni di prenotazione e la privacy policy",
    submit_request: "Invia Richiesta di Prenotazione",
    submitting_request: "Invio in corso…",
    retry: "Riprova",
    availability_select_date: "Seleziona prima una data.",
    availability_loading: "Verifica disponibilità…",
    availability_unavailable: "Non è stato possibile verificare la disponibilità. Controlla la connessione e riprova.",
    availability_no_slots: "Nessun turno disponibile per questi ospiti. Scegli un'altra data.",
    slot_two_top_full: "Tavoli da 2 esauriti",
    slot_past: "Orario trascorso",
    event_err_type: "Seleziona il tipo di evento.",
    event_err_fascia: "Seleziona una fascia oraria.",
    event_err_description: "Descrivi l'evento con almeno 10 caratteri.",
    submit_err_terms: "Devi accettare le condizioni per procedere.",
    submit_err_missing: "Completa tutti i campi obbligatori.",
    submit_err_missing_specific: "Manca:",
    field_date_lc: "data",
    field_time_lc: "orario",
    field_date_required: "Seleziona una data per continuare.",
    field_time_required: "Scegli un orario per continuare.",
    progress_date: "Data",
    progress_time: "Orario",
    progress_guests: "Coperti",
    progress_terms: "Termini",
    submit_err_slot_full: "Turno al completo. Scegli un altro turno.",

    slot_remaining: "posti rimasti",
    slot_full: "Turno completo",

    // Occasion presets
    occasion_birthday: "Compleanno",
    occasion_anniversary: "Anniversario",
    occasion_romantic: "Cena romantica",
    occasion_friends: "Tra amici",
    occasion_business: "Lavoro",
    occasion_proposal: "Proposta",
    occasion_other: "Altro",

    // Allergies presets
    allergy_gluten: "Glutine",
    allergy_lactose: "Lattosio",
    allergy_shellfish: "Crostacei",
    allergy_nuts: "Frutta a guscio",
    allergy_eggs: "Uova",
    allergy_fish: "Pesce",
    allergy_soy: "Soia",
    allergy_celery: "Sedano",
    allergy_sulfites: "Solfiti",
    allergy_vegetarian: "Vegetariano",
    allergy_vegan: "Vegano",

    // Success
    success_title: "Richiesta inviata!",
    success_subtitle:
      "La tua prenotazione è in attesa di conferma. Riceverai una risposta entro 24 ore.",
    status_pending: "In attesa",
    status_pending_short: "PENDING",
    status_pending_note: "Stato: In attesa di conferma dall'amministratore",
    make_another: "Fai un'altra prenotazione",
    contact_whatsapp: "Scrivici su WhatsApp",
    contact_whatsapp_hint: "Ricevi la conferma diretta in chat",
    whatsapp_redirecting: "Apertura WhatsApp in corso…",
    whatsapp_open_manual: "Apri WhatsApp manualmente",

    // Payment / PayPal
    pay_optional_title: "Vuoi anticipare ora?",
    pay_optional_subtitle: "Paga l'anticipo subito e prenota in modo sicuro. Puoi anche pagarlo dopo, quando l'admin avrà confermato.",
    pay_amount_label: "Anticipo da pagare",
    pay_already_paid: "Anticipo già pagato",
    pay_skip: "Salta — pagherò dopo la conferma",
    pay_now: "Paga ora",
    pay_page_title: "Completa il pagamento",
    pay_page_subtitle: "Solo un ultimo passo per confermare la tua prenotazione.",
    pay_success_title: "Pagamento ricevuto!",
    pay_success_subtitle: "Grazie! La tua prenotazione è ora completamente confermata. A presto.",
    pay_polling_title: "Verifica del pagamento in corso…",
    pay_expired_title: "Sessione di pagamento scaduta",
    pay_error_title: "Errore nel pagamento",
    pay_cancel_title: "Pagamento annullato",
    pay_back_home: "Torna alla home",
    summary_date: "Data",
    summary_time: "Orario",
    summary_guests: "Coperti",
    summary_deposit: "Anticipo",
    summary_service: "Servizio",

    // Admin
    admin_gate_title: "Accesso Admin",
    admin_gate_subtitle: "Inserisci la password per accedere.",
    admin_password: "Password",
    admin_enter: "Accedi",
    admin_wrong_pwd: "Password errata",

    admin_title: "Pannello Prenotazioni",
    kpi_pending: "In attesa",
    kpi_confirmed: "Confermate",
    kpi_rejected: "Rifiutate",
    kpi_events_pending: "Eventi in attesa",

    tab_all: "Tutte",
    tab_pending: "In attesa",
    tab_confirmed: "Confermate",
    tab_rejected: "Rifiutate",

    // Filters
    filter_search_placeholder: "Cerca per nome, cognome, @handle, email…",
    filter_service_label: "Servizio",
    filter_service_all: "Tutti",
    filter_service_reservations: "Prenotazioni",
    filter_service_events: "Solo eventi",
    filter_date_from: "Dal",
    filter_date_to: "Al",
    filter_clear: "Pulisci filtri",
    filter_results_count: "risultati",

    action_confirm: "Conferma",
    action_reject: "Rifiuta",
    action_cancel: "Annulla",
    action_reset: "Ripristina",
    action_delete: "Elimina",
    delete_booking_tooltip: "Elimina definitivamente questa prenotazione",
    delete_confirm_text: "Eliminare definitivamente questa prenotazione? L'operazione non è reversibile.",
    cleanup_expired_button: "Pulisci scadute/rifiutate",
    cleanup_expired_confirm: "Elimina tutte le prenotazioni rifiutate e quelle in attesa/non pagate per date già passate?",
    view_list_label: "Lista",
    view_calendar_label: "Calendario",
    calendar_empty_day: "Nessuna prenotazione per questo giorno",
    reject_confirm_text:
      "Sicuro di voler rifiutare? Questo invierà una notifica al cliente.",
    reject_yes: "Sì, rifiuta",
    toast_confirmed: "Prenotazione confermata per",
    toast_rejected: "Prenotazione rifiutata per",
    toast_reset: "Stato ripristinato",
    toast_saved: "Salvato",
    toast_edit_locked_paid: "Non posso modificare: prenotazione già pagata.",
    event_confirm_amount_label: "Imposta l'anticipo per questo evento (€). Verrà inviato al cliente con il link di pagamento.",
    event_confirm_submit: "Conferma e richiedi €",
    edit_deposit_tooltip: "Clicca per modificare l'anticipo",
    custom_message_label: "Messaggio personalizzato (incluso nell'email di conferma)",
    custom_message_placeholder: "Es: Ti aspettiamo con un dolce alla mandorla per il tuo compleanno!",
    custom_message_add: "Aggiungi messaggio personalizzato nell'email",
    action_save: "Salva",
    empty_title: "Nessuna prenotazione",
    empty_subtitle: "Nessuna prenotazione in questa categoria",

    status_confirmed_short: "CONFERMATA",
    status_rejected_short: "RIFIUTATA",

    required_suffix: "*",

    back: "Indietro",
  },
  en: {
    admin_link: "Admin",
    admin_logout: "Logout",
    admin_settings: "Settings",
    settings_deposit_label: "Deposit per guest",
    settings_deposit_hint: "Amount charged per guest as a deposit on all dinner reservations.",
    settings_deposit_per_person_suffix: "per guest",
    settings_reconcile_label: "Sync Stripe payments",
    settings_reconcile_hint: "Check Stripe for the status of all bookings still awaiting payment and finalize the ones already paid.",
    settings_reconcile_action: "Sync now",
    settings_capacity_label: "Dinner slot capacity",
    settings_capacity_hint: "Set the maximum number of seats bookable per dinner slot. Once a slot reaches its limit, customers won't be able to book it anymore.",
    settings_capacity_save: "Save",
    toast_reconcile_finalized: "bookings updated to paid",
    toast_reconcile_none: "Nothing to sync",
    toast_reconcile_checked: "checked",
    mark_paid_button: "Mark paid",
    mark_paid_tooltip: "Manually mark this booking as paid (admin override)",
    paid_checkbox: "Paid",
    paid_after_cancel: "Paid after cancellation: check seats",
    check_stripe_button: "Check on Stripe",
    toast_stripe_paid: "Stripe confirms the payment: booking updated",
    toast_stripe_unpaid: "No payment found on Stripe yet",
    toast_stripe_unreachable: "Stripe unreachable, try again shortly",
    tab_awaiting_payment: "Awaiting payment",
    tab_paid: "Paid",
    tab_cancelled: "Cancelled",
    kpi_awaiting_payment: "Awaiting payment",
    kpi_paid: "Paid",
    kpi_cancelled: "Cancelled",
    status_cancelled_short: "CANCELLED",
    payment_countdown: "Time to pay",
    payment_time_over: "Time is up, cancelling",
    sort_label: "Sort by",
    sort_upcoming: "Upcoming first",
    sort_date_asc: "Booking date ↑",
    sort_date_desc: "Booking date ↓",
    sort_created_desc: "Newest request",
    sort_created_asc: "Oldest request",
    sort_name_asc: "Name A–Z",
    sort_guests_desc: "Largest party",
    filter_service_dinner: "Dinner",
    filter_service_lunch: "Lunch",
    settings_lunch_capacity_label: "Covers per time — Sunday lunch",
    settings_lunch_capacity_hint: "Applies to each of the 12:00 — 14:45 times.",
    lunch_sunday_only_notice: "Lunch is available on Sundays only, with arrivals every 15 minutes.",
    pay_countdown_label: "Time left to pay",
    pay_countdown_hint: "If payment is not received in time, the reservation is cancelled automatically.",
    pay_cancelled_title: "Reservation cancelled",
    pay_cancelled_subtitle: "The payment window has expired and the seat has been released. You can send a new request.",
    mark_paid_confirm: "Mark this booking as PAID? It will be confirmed and the customer will receive a confirmation email.",
    toast_marked_paid: "Booking marked as paid",
    theme_toggle: "Theme",
    language: "Language",

    tagline: "Find your Soul",
    landing_description:
      "Book your table in seconds. We'll confirm your request within 24 hours.",
    landing_choose_service: "Choose your perfect moment",

    cta_event_label: "For your private event",
    cta_event_subtitle: "",
    event_step_title: "Let's design your event",
    event_step_subtitle:
      "Tell us about your idea — our team will get back to you within 48 hours.",
    event_field_type: "Event type",
    event_field_type_other: "Specify the type",
    event_field_guests: "Expected number of guests",
    event_field_date: "Preferred date",
    event_field_fascia: "Preferred time slot",
    event_field_description: "Tell us about your idea",
    event_description_placeholder:
      "E.g. I'd love to celebrate my 30th in a private room with a single long table, DJ from 10pm and a surprise cake…",
    event_field_budget: "Approx. budget per person (€, optional)",
    event_field_setup: "Special setup (optional)",
    event_submit: "Send event request",

    event_type_birthday: "Birthday",
    event_type_anniversary: "Anniversary",
    event_type_wedding: "Wedding",
    event_type_baptism: "Baptism",
    event_type_corporate: "Corporate dinner",
    event_type_private: "Private party",
    event_type_other: "Other",

    fascia_lunch: "Lunch (12—15)",
    fascia_aperitivo: "Aperitivo (16—19)",
    fascia_dinner: "Dinner (19—22)",
    fascia_late: "Late night (22—24)",

    setup_private_room: "Private room",
    setup_single_table: "Single long table",
    setup_dj_music: "DJ / music",
    setup_decorations: "Decorations",
    setup_cake: "Cake",
    setup_dedicated_service: "Dedicated service",

    event_success_title: "Event request sent!",
    event_success_subtitle:
      "We sent you a confirmation email. Our team will reach out within 48 hours.",
    event_admin_label: "Event",

    service_lunch: "Lunch",
    service_aperitivo: "Aperitivo",
    service_dinner: "Dinner",
    service_event: "Private event",
    service_lunch_hours: "Sundays only · 12:00 — 14:45",
    service_aperitivo_hours: "16:00 — 19:00",
    service_dinner_hours: "Two seatings · 20:30 — 24:00",
    service_lunch_subtitle: "Sunday lunch, arrivals every 15 minutes",
    service_aperitivo_subtitle: "Drinks at sunset, every 30 min",
    service_dinner_subtitle: "Two candlelit seatings",

    auth_title: "How would you like to book?",
    auth_subtitle: "Pick the fastest way to identify yourself.",
    login_instagram: "Log in with Instagram",
    login_instagram_sub: "Quick with your handle",
    book_as_guest: "Book as a guest",
    book_as_guest_sub: "Enter your details",

    address_line_1: "Via Campi Flegrei 15",
    address_line_2: "80078 Pozzuoli",
    copyright: "Copyright © 2026 VAGALUME, All rights reserved",
    credits_developed_by: "Booking app developed by",

    ig_modal_title: "Log in with Instagram",
    ig_modal_subtitle: "Use your handle to book quickly.",
    ig_username_label: "Instagram username",
    ig_username_placeholder: "your_handle",
    ig_continue: "Continue",
    ig_cancel: "Cancel",
    ig_error_required: "Please enter your Instagram handle.",

    guest_title: "Book as a guest",
    guest_subtitle: "Just a few details to get started.",
    field_nome: "First name",
    field_cognome: "Last name",
    field_instagram: "Instagram handle (optional)",
    field_email: "Email",
    field_phone: "Phone (WhatsApp)",
    phone_hint: "International format, e.g. +39 333 1234567",
    guest_continue: "Continue →",
    err_required: "Required",
    err_invalid_email: "Invalid email",
    err_invalid_phone: "Invalid phone number",

    hello: "Hi",
    step_title: "Your reservation",
    step_subtitle: "Pick a date, time and party size.",
    field_service: "Service",
    change_service: "Change",
    field_date: "Reservation date",
    date_placeholder: "Select a date",
    field_time: "Time",
    field_time_dinner: "Seating",
    field_guests: "Party size",
    field_deposit_per_person: "Deposit per guest",
    field_deposit_per_person_hint: "Pick the deposit amount per guest. You will only be asked to pay after we confirm your reservation.",
    field_deposit_total: "Total deposit",
    field_notes: "Notes / Special requests",
    notes_placeholder: "Allergies, special occasion, table preferences…",
    chars_left: "characters left",
    field_occasion: "Occasion (optional)",
    field_occasion_other: "Tell us more",
    field_allergies: "Allergies / preferences (optional)",
    field_allergies_note: "Other allergy notes",
    allergy_counts_label: "How many people for each?",
    allergy_counts_hint:
      "Telling us the exact number saves us calling you back before service.",
    allergy_count_decrease: "Decrease people",
    allergy_count_increase: "Increase people",
    field_birthday: "Your birthday (optional)",
    birthday_hint: "So we can send you a little something every year",

    deposit_label: "Deposit required",
    deposit_hint:
      "The deposit payment will be requested separately after confirmation. An admin will confirm within 24 hours.",
    dinner_only_notice:
      "This reservation is intended exclusively for the dinner service; it is considered void for any other use.",
    terms_checkbox:
      "I have read and accepted the booking conditions and the privacy policy",
    submit_request: "Send Reservation Request",
    submitting_request: "Sending request…",
    retry: "Try again",
    availability_select_date: "Select a date first.",
    availability_loading: "Checking availability…",
    availability_unavailable: "We could not check availability. Check your connection and try again.",
    availability_no_slots: "No seatings are available for this party size. Please choose another date.",
    slot_two_top_full: "Tables for 2 fully booked",
    slot_past: "Time has passed",
    event_err_type: "Please select the event type.",
    event_err_fascia: "Please select a time period.",
    event_err_description: "Please describe the event using at least 10 characters.",
    submit_err_terms: "You must accept the conditions to proceed.",
    submit_err_missing: "Please complete all required fields.",
    submit_err_missing_specific: "Missing:",
    field_date_lc: "date",
    field_time_lc: "time",
    field_date_required: "Pick a date to continue.",
    field_time_required: "Pick a time slot to continue.",
    progress_date: "Date",
    progress_time: "Time",
    progress_guests: "Guests",
    progress_terms: "Terms",
    submit_err_slot_full: "This seating is full. Please pick another one.",

    slot_remaining: "seats left",
    slot_full: "Fully booked",

    occasion_birthday: "Birthday",
    occasion_anniversary: "Anniversary",
    occasion_romantic: "Romantic dinner",
    occasion_friends: "With friends",
    occasion_business: "Business",
    occasion_proposal: "Proposal",
    occasion_other: "Other",

    allergy_gluten: "Gluten",
    allergy_lactose: "Lactose",
    allergy_shellfish: "Shellfish",
    allergy_nuts: "Tree nuts",
    allergy_eggs: "Eggs",
    allergy_fish: "Fish",
    allergy_soy: "Soy",
    allergy_celery: "Celery",
    allergy_sulfites: "Sulfites",
    allergy_vegetarian: "Vegetarian",
    allergy_vegan: "Vegan",

    success_title: "Request sent!",
    success_subtitle:
      "Your reservation is awaiting confirmation. You'll hear from us within 24 hours.",
    status_pending: "Pending",
    status_pending_short: "PENDING",
    status_pending_note: "Status: Awaiting admin confirmation",
    make_another: "Make another reservation",
    contact_whatsapp: "Message us on WhatsApp",
    contact_whatsapp_hint: "Get direct confirmation in chat",
    whatsapp_redirecting: "Opening WhatsApp…",
    whatsapp_open_manual: "Open WhatsApp manually",

    // Payment / PayPal
    pay_optional_title: "Pay your deposit now?",
    pay_optional_subtitle: "Pay the deposit upfront and lock your reservation. You can also pay it later, after the admin confirms.",
    pay_amount_label: "Deposit due",
    pay_already_paid: "Deposit already paid",
    pay_skip: "Skip — I'll pay after confirmation",
    pay_now: "Pay now",
    pay_page_title: "Complete your payment",
    pay_page_subtitle: "One last step to confirm your reservation.",
    pay_success_title: "Payment received!",
    pay_success_subtitle: "Thank you! Your reservation is now fully confirmed. See you soon.",
    pay_polling_title: "Verifying your payment…",
    pay_expired_title: "Payment session expired",
    pay_error_title: "Payment error",
    pay_cancel_title: "Payment cancelled",
    pay_back_home: "Back to home",
    summary_date: "Date",
    summary_time: "Time",
    summary_guests: "Guests",
    summary_deposit: "Deposit",
    summary_service: "Service",

    admin_gate_title: "Admin access",
    admin_gate_subtitle: "Enter the password to continue.",
    admin_password: "Password",
    admin_enter: "Enter",
    admin_wrong_pwd: "Wrong password",

    admin_title: "Reservations",
    kpi_pending: "Pending",
    kpi_confirmed: "Confirmed",
    kpi_rejected: "Rejected",
    kpi_events_pending: "Pending events",

    tab_all: "All",
    tab_pending: "Pending",
    tab_confirmed: "Confirmed",
    tab_rejected: "Rejected",

    // Filters
    filter_search_placeholder: "Search by name, surname, @handle, email…",
    filter_service_label: "Service",
    filter_service_all: "All",
    filter_service_reservations: "Reservations",
    filter_service_events: "Events only",
    filter_date_from: "From",
    filter_date_to: "To",
    filter_clear: "Clear filters",
    filter_results_count: "results",

    action_confirm: "Confirm",
    action_reject: "Reject",
    action_cancel: "Cancel",
    action_reset: "Reset",
    action_delete: "Delete",
    delete_booking_tooltip: "Permanently delete this booking",
    delete_confirm_text: "Permanently delete this booking? This cannot be undone.",
    cleanup_expired_button: "Clean up expired/rejected",
    cleanup_expired_confirm: "Delete all rejected bookings and unpaid/pending ones for past dates?",
    view_list_label: "List",
    view_calendar_label: "Calendar",
    calendar_empty_day: "No bookings for this day",
    reject_confirm_text: "Are you sure? This will notify the customer.",
    reject_yes: "Yes, reject",
    toast_confirmed: "Reservation confirmed for",
    toast_rejected: "Reservation rejected for",
    toast_reset: "Status reset",
    toast_saved: "Saved",
    toast_edit_locked_paid: "Cannot edit: booking already paid.",
    event_confirm_amount_label: "Set the deposit for this event (€). It will be sent to the customer with a payment link.",
    event_confirm_submit: "Confirm & request €",
    edit_deposit_tooltip: "Click to edit the deposit",
    custom_message_label: "Custom message (included in the confirmation email)",
    custom_message_placeholder: "E.g.: We will be waiting for you with an almond cake for your birthday!",
    custom_message_add: "Add a custom message to the email",
    action_save: "Save",
    empty_title: "No reservations",
    empty_subtitle: "No reservations in this category",

    status_confirmed_short: "CONFIRMED",
    status_rejected_short: "REJECTED",

    required_suffix: "*",

    back: "Back",
  },
};

// Centralized lists used across the form/UI
export const OCCASIONS = [
  "birthday",
  "anniversary",
  "romantic",
  "friends",
  "business",
  "proposal",
  "other",
];

export const ALLERGIES = [
  "gluten",
  "lactose",
  "shellfish",
  "nuts",
  "eggs",
  "fish",
  "soy",
  "celery",
  "sulfites",
  "vegetarian",
  "vegan",
];

// Pretty time-range label for dinner slots (start of slot → label)
export const DINNER_SLOT_LABELS = {
  "20:30": "20:30 — 22:30",
  "22:30": "22:30 — 00:00",
};

// All possible dinner slots (Mon–Thu extended set already includes the 2 weekend ones).
export const ALL_DINNER_SLOTS = [
  "19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", "23:00", "23:30",
];

// Mon–Thu: 20:30/22:30 are plain 30-min slots among the 10 extended slots.
// Fri/Sat/Sun: they're the only 2 "seatings" so we show the full range.
export function dinnerSlotLabel(dateIso, time) {
  if (!dateIso) return DINNER_SLOT_LABELS[time] || time;
  const day = new Date(`${dateIso}T00:00:00`).getDay(); // 0=Sun … 6=Sat
  const isWeekendSeating = day === 0 || day === 5 || day === 6;
  return isWeekendSeating ? (DINNER_SLOT_LABELS[time] || time) : time;
}

// Event presets (must match backend EVENT_TYPES / EVENT_FASCIA / EVENT_SETUP)
export const EVENT_TYPES = [
  "birthday",
  "anniversary",
  "wedding",
  "baptism",
  "corporate",
  "private",
  "other",
];

export const EVENT_FASCIA = ["lunch", "aperitivo", "dinner", "late"];

export const EVENT_SETUP = [
  "private_room",
  "single_table",
  "dj_music",
  "decorations",
  "cake",
  "dedicated_service",
];

export function detectLang() {
  if (typeof navigator === "undefined") return "it";
  const l = (navigator.language || "it").toLowerCase();
  return l.startsWith("en") ? "en" : "it";
}
